import React, { useContext } from "react";
import * as notify from "shared/notify";

import { ShotContext } from "../context/index";
import { TaskContext } from "contexts/task";
import { DEFAULT_LOCALE, CODING_SHOT } from "../lib/helpers";

const BulkSelect = () => {
    const { task } = useContext(TaskContext);
    const { editingSources, packageTemplate, selectedLocale, shotsByLocale, updateProperty } = useContext(ShotContext);

    const handleSelectAll = () => {
        const selectKeys = shotsByLocale[selectedLocale.value].reduce((arr, s) => {
            const isCoding = !s.imageViewCode || s.imageViewCode === CODING_SHOT.imageViewCode ? true : false;

            if (!s.isSelected && !!s.uneditedBlobKey && !isCoding) {
                arr.push(s.key);
            }

            return arr;
        }, []);

        updateProperty(selectKeys, "isSelected", true, false);
    };

    const handleUnselectAll = () => {
        const unSelectKeys = shotsByLocale[selectedLocale.value].reduce((arr, s) => {
            if (s.isSelected) {
                arr.push(s.key);
            }

            return arr;
        }, []);
        updateProperty(unSelectKeys, "isSelected", false, false);
    };

    const updateEdingSource = (value) => {
        const selectedItems = shotsByLocale[selectedLocale.value].reduce((arr, s) => {
            if (value === 4 && s.isSelected) {
                const isDefaultImageView = selectedLocale.value === DEFAULT_LOCALE.value && packageTemplate.defaultImageView && packageTemplate.defaultImageView === s.imageViewCode;
                const isEcomView = s.imageViewCode === "Ecom";

                if (isDefaultImageView || isEcomView || s.isPremiumEditing) {
                    updateProperty([s.key], "isSelected", false, false);
                    const shotType = s.isPremiumEditing ? "Premium" : "Ecom";
                    notify.warning(`${shotType} shot was not updated as it can not be skipped.`);

                    return arr;
                }
            }

            if (s.isSelected) {
                arr.push(s.key);
            }

            return arr;
        }, []);

        if (selectedItems.length <= 0) {
            notify.warning("Please select a photo to bulk select editing source.");

            return;
        }

        updateProperty(selectedItems, "editingSourceId", value);
    };

    return (
        <>
            <div className="editing-source-select">
                (<span className="count">{(shotsByLocale[selectedLocale.value] || []).filter((s) => s.isSelected).length} selected</span>
                <button className="button -text" onClick={handleSelectAll}>
                    Select All
                </button>
                <button className="button -text" onClick={handleUnselectAll}>
                    Deselect All
                </button>
                )
            </div>
            <div className="editing-source-options">
                {!task.isCompleted &&
                    editingSources &&
                    editingSources.map((es) => (
                        <button
                            key={`button_${es.value}`}
                            className="button -text"
                            onClick={() => {
                                updateEdingSource(es.value);
                            }}
                        >
                            {es.text}
                        </button>
                    ))}
            </div>
        </>
    );
};

export default BulkSelect;
